import { memo } from 'react'

import CreateFinalAfterInactivity, {
  InactivityType
} from './containers/CreateFinalAfterInactivity'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getAge } from 'utils/date'
import {
  determineTimeout,
  TIMEOUT_FIVE_MINUTES,
  TIMEOUT_TWO_MINUTES
} from 'InactivityContainer.helpers'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import { Experiments } from 'CustomOptimizelyProvider'
import { getAgeGroupFromAge } from 'stores/helpers/AgeGroups'
import { AgeGroup } from 'constants/components'

type InactivityProps = {
  handleSubmit: () => void
}

const InactivityContainer = ({ handleSubmit }: InactivityProps) => {
  const {
    rootStore: {
      experimentData,
      page: { config },
      traversal: {
        data: {
          debtors: {
            primary: {
              personal: { birthday }
            }
          }
        }
      }
    }
  } = useRootStore()

  const debtorsAge = getAge(birthday)
  const isInCAT4116Variation =
    // @ts-ignore - experimentData type needs refinement for dynamic access
    experimentData[Experiments.CAT_4116_DAC_FC_ALLIGNMENT] ===
    PossibleVariants.VARIATION_B

  let timeout = determineTimeout(debtorsAge, config.name)
  const ageGroup = getAgeGroupFromAge(debtorsAge)

  if (!timeout) {
    return null
  }

  if (isInCAT4116Variation && ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
    timeout = TIMEOUT_TWO_MINUTES
  }

  return (
    <>
      <CreateFinalAfterInactivity
        timeout={TIMEOUT_FIVE_MINUTES}
        inactivityType={InactivityType.PAYOUT_ACCOUNT_INACTIVITY}
        onNext={handleSubmit}
      />
      <CreateFinalAfterInactivity
        timeout={timeout}
        inactivityType={InactivityType.DAC_INACTIVITY}
        onNext={handleSubmit}
      />
    </>
  )
}

export default memo(InactivityContainer)
